class TagList {

	constructor() {
		this.cacheLife = 60 * 1000
		this.items = []
		this.modified = 0
	}

	async get() {
		const now = Date.now()
		if (now - this.modified >= this.cacheLife) {
			this.items = await fetch(zzl.appBase + '/tag/list.json?t=' + now)
				.then(response => response.json())
			this.modified = Date.now()
		}
		return this.items
	}
}

const instance = new TagList()

export default instance
